export async function handleTableDataRequest(uuids, tabVal, permissions, sendRequest, levelId) {
    const tabApiConfig = {
        all_device: { uuid: uuids.all, type: "all" },
        access_point: { uuid: uuids.ap, type: "ap" },
        switch: { uuid: uuids.sw, type: "switch" },
        router: { uuid: uuids.rtr, type: "router" },
        inventory: { uuid: uuids.inv, type: "all" }, // inventory uses all devices API
        proxy: { uuid: uuids.proxy, type: "proxy" },
    };

    const currentTab = tabApiConfig[tabVal];
    const standalone = !levelId.org || Object.keys(levelId.org).length === 0;
    const baseUrl = standalone ? `/orgs/:orgId` : `/ents/:entId/orgs/:orgId`;
    const restfulParams = standalone ? { orgId: levelId.realm, siteId: levelId.site } : { entId: levelId.realm, orgId: levelId.org, siteId: levelId.site };

    const apiKey = {
        org: `${baseUrl}/devices.read`,
        site: `${baseUrl}/sites/:siteId/devices.read`
    };

    if (currentTab && permissions === 'orgTable') {
        sendRequest(
            apiKey.org,
            currentTab.uuid,
            restfulParams,
            { type: currentTab.type }
        );
    }

    if (currentTab && permissions === 'siteTable') {
        sendRequest(
            apiKey.site,
            currentTab.uuid,
            restfulParams,
            { type: currentTab.type }
        );
    }
}

export async function handleSiteInventoryRequest(uuid, sendRequest, levelId) {
    const standalone = !levelId.org || Object.keys(levelId.org).length === 0;
    const baseUrl = standalone ? `/orgs/:orgId` : `/ents/:entId/orgs/:orgId`;
    const restfulParams = standalone ? { orgId: levelId.realm, siteId: levelId.site } : { entId: levelId.realm, orgId: levelId.org, siteId: levelId.site };

    const apiKey = {
        site: `${baseUrl}/sites/:siteId/devices/inventory.read`
    };

    sendRequest(
        apiKey.site,
        uuid,
        restfulParams,
        {}
    );
}

export function handleSiteProxyDevicesRequest(levelId) {
    const standalone = !levelId.org || Object.keys(levelId.org).length === 0;
    let resource = '';

    if (standalone) {
        resource = `/orgs/${levelId.realm}/sites/${levelId.site}/devices/inventory`;
    } else {
        resource = `/ents/${levelId.realm}/orgs/${levelId.org}/sites/${levelId.site}/devices/inventory`;
    }

    return resource;
}